import React, { useEffect, useState } from 'react';
import Access from "../../components/Access";
import axios from 'axios';
import qs from 'qs';
import BounceLoader from "react-spinners/BounceLoader";
import 'react-notifications/lib/notifications.css';
import {NotificationContainer, NotificationManager} from 'react-notifications';
import AddlineSaisie from './AddlineSaisie';
import { addSpace, exportGrilleSaisieCsv } from '../../components/Tools';
import { ReactComponent as Add } from '../../Img/icon-add.svg';
import { ReactComponent as Check } from '../../Img/icon-check.svg';
import { ReactComponent as CloseEye } from '../../Img/icon-close-eye.svg';
import { ReactComponent as OpenEye } from '../../Img/icon-open-eye.svg';
import { ReactComponent as Download } from '../../Img/icon-download.svg';

const GrilleSaisie = (props) =>
{
    let recdep = window.location.pathname.split('/')[4];
    const [validButton, setValidButton] = useState(false);
    const [modalVisible, setModalVisible] = useState(false);
    const [souscomptes, setSouscomptes] = useState(true);
    const heightObject = window.innerHeight/1.9;

    const greyChapter = '#DBDBDB';
    const purple = '#6571FE';
    const blue = '#069BD3';
    const smoothGrey = '#f4f4f4';
    const green = '#59B44A';


    async function ligneTotal(tmp)
    {
        await props.annees.forEach(annee => {
            var total = 0
            tmp.forEach((line) => {
                if (line[0][0].includes('REEL') || line[0][0].includes('OOB')) {
                    line.forEach((cel) => {
                        if (cel[0] === annee) {
                            if (cel[1][recdep] !== '0' && cel[1][recdep] !== 0) {
                                total = total + parseFloat(cel[1][recdep]);
                            }
                        }
                    });
                }
            });
            tmp.forEach((line, i) => {
                if (line[0][0].includes('OBNET')) {
                    line.forEach((cel, j) => {
                        if (cel[0] === annee) {
                            if ((Math.round(total*100)/100) != tmp[i][j][1][recdep]) {
                                tmp[i][j][1][recdep] = Math.round(total*100)/100;
                            }
                        }
                    });
                }
            });
        });

        await props.setObjet(tmp);
        await props.setAff(!props.aff);
    }


    async function totalreelles(tmp)
    {
        await props.annees.forEach(annee => {
            var total = 0
            tmp.forEach((line) => {
                if (line[0][3] === 3 && line[0][1] !== 'R001' && line[0][1] !== 'R002' && line[0][1] !== 'D001' && line[0][1] !== 'D002') {
                    line.forEach((cel) => {
                        if (cel[0] === annee) {
                            if (cel[1][recdep] !== '0' && cel[1][recdep] !== 0) {
                                total = total + parseFloat(cel[1][recdep]);
                            }
                        }
                    });
                }
            });
            tmp.forEach((line, i) => {
                if (line[0][0].includes('REEL')) {
                    line.forEach((cel, j) => {
                        if (cel[0] === annee) {
                            if ((Math.round(total*100)/100) != tmp[i][j][1][recdep]) {
                                tmp[i][j][1][recdep] = Math.round(total*100)/100;
                            }
                        }
                    });
                }
            });
        });
        await ligneTotal(tmp)
    }
    

    /**
     * Calcule la somme de tous les éléments appartenant à un chapitre pour une année donnée
     * et met à jour la valeur du chapitre avec cette somme
     */
    async function sumChapters(chapterMatricule, an, tmp)
    {
        // Étape 1 : Parcourir toutes les lignes pour additionner les montants
        var chapterCount = 0;
        await tmp.forEach((line, i) => {
            // Chercher les lignes dont l'élément parent (indice 4) correspond au chapitre
            // Exclure 2014M4312 qui est une exception (ne doit pas recalculer ses enfants)
            if (tmp[i][0][4] === chapterMatricule && !chapterMatricule.includes('2014M4312')) {
                var j = 1;
                // Parcourir chaque année de cette ligne
                while(tmp[i][j])
                {
                    // Si c'est l'année recherchée
                    if (line[j][0] === an) {
                        var montant = 0;
                        // Récupérer le montant et l'ajouter à la somme
                        if (parseFloat(tmp[i][j][1][recdep])) {
                            montant = parseFloat(tmp[i][j][1][recdep]);
                        }
                        chapterCount += montant;
                    }
                    j++;
                }
            }
        });

        // Étape 2 : Trouver la ligne du chapitre et mettre à jour sa valeur avec la somme calculée
        await tmp.forEach((line, i) => {
            // Chercher la ligne dont le matricule est égal au chapterMatricule (le chapitre lui-même)
            if (line[0][0] === chapterMatricule && !chapterMatricule.includes('2014M4312'))
            {
                var j = 1;
                // Parcourir chaque année de ce chapitre
                while(tmp[i][j])
                {
                    // Si c'est l'année recherchée, mettre à jour avec la somme
                    if (tmp[i][j][0] === an)
                    {
                        tmp[i][j][1][recdep] = chapterCount;
                    }
                    j++;
                }
            }
        });
        return tmp;
    }


    async function recalcule(tmp)
    {
        var i = 0
        while(tmp[i])
        {
            if (tmp[i][0][3] !== 3 && !tmp[i][0][0].includes('OOB') && !tmp[i][0][0].includes('RAR')
                && !tmp[i][0][0].includes('001')  && !tmp[i][0][0].includes('002'))
            {
                var j = 1
                while (tmp[i][j])
                {
                    await sumChapters(tmp[i][0][0], tmp[i][j][0], tmp);
                    j++;
                }
            }
            i++;
        }
        var i = 0
        while(tmp[i])
        {
            if (tmp[i][0][3] !== 3 && !tmp[i][0][0].includes('OOB') && !tmp[i][0][0].includes('RAR')
                && !tmp[i][0][0].includes('001') && !tmp[i][0][0].includes('002'))
            {
                var j = 1
                while (tmp[i][j])
                {
                    await sumChapters(tmp[i][0][0], tmp[i][j][0], tmp);
                    j++;
                }
            }
            i++;
        }
        props.setObjet(tmp);
        await totalreelles(tmp)
    }


    useEffect(() => {
        if (props.objet.length != 0) {
            recalcule(props.objet);
        }
    }, [props.objet])


    async function updateObjetLine(matricule, an, montant = '', manuel = true)
    {
        var tmp = props.objet;
        var i = 0;
        while(i < tmp.length)
        {
            if (tmp[i][0][0] === matricule)
            {
                var chapterMatricule = tmp[i][0][4];
                var j = 1;
                while(tmp[i][j])
                {
                    if (an === tmp[i][j][0])
                    {
                        if (montant === '0') {
                            montant = 0;
                        }
                        tmp[i][j][1][recdep] = montant;
                    }
                    j++;
                }
            }
            i++;
        }
        return sumChapters(chapterMatricule, an, tmp);
    }

    async function validation()
    {
        var ret = true;
        var tab_tmp = props.objet;
        var cut_tab = {};
        var tmpi = 0

        while(tmpi <= tab_tmp.length / 10)
        {
            cut_tab[tmpi] = tab_tmp.slice((tmpi * 10), 10 + (tmpi * 10))
            const params = {
                'updateGrilleSaisieRetro': true,
                'fctinv': props.fctinv,
                'recdep': props.recdep,
                'hypothese': props.hypothese,
                'id_budget': props.id_budget,
                'grilleSaisie': cut_tab[tmpi]
            }
            
            await axios.post("https://app-slfinance.fr/api/datas_brut.php", qs.stringify(params))
            .then((ret) => {
            })
            .catch((err) => {
                ret = false;
                console.warn(err);
            })
            tmpi++;
        }

        return ret;
    }

	return (
        <div>
            <NotificationContainer />
            <Access needConnection={true} type_user={[0]}>
                {props.objet.length === 0 || validButton?
                <div style={{flex: 1, margin: 100, display: 'flex'}}>
                    <div style={{flex: 1}}></div>
                    <BounceLoader color={purple} />
                    <div style={{flex: 1}}></div>
                </div>
                :
                <div style={{flex: 1}}>
                    <AddlineSaisie
                    user={props.user}
                    modalVisible={modalVisible}
                    setModalVisible={setModalVisible}
                    annees={props.annees}
                    id_budget={props.id_budget}
                    fctinv={props.fctinv}
                    recdep={props.recdep}
                    hypothese={props.hypothese}
                    />
                    
                    <div style={{display: 'flex'}}>
                        {props.user && props.user.droits && props.user.droits.retro_saisie.includes("M") &&
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: green, color: 'white', marginLeft: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}
                            onClick={async () => {
                                setModalVisible(true)
                                await validation()
                                .then(() => {
                                    NotificationManager.success("Grille sauvegardée", '', 700);
                                })
                            }}
                        >
                            <Add width="12"/>
                            <p style={{marginLeft: 5}}>Nouvelle ligne</p>
                        </button>
                        }
                        
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: purple, color: 'white', marginLeft: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}
                            onClick={() => {
                                setSouscomptes(!souscomptes);
                            }}
                        >
                            {!souscomptes?
                            <OpenEye width="12"/>
                            :
                            <CloseEye width="12"/>
                            }
                            <p style={{marginLeft: 5}}>{!souscomptes?'Afficher':'Cacher'} les sous comptes</p>
                        </button>

                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: purple, color: 'white', marginLeft: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft:10, paddingRight: 10}}
                            onClick={async () => {
                                // Utilisez une fonction de "sanitize" pour nettoyer les chaînes utilisées dans le nom de fichier
                                function sanitizeFilename(str) {
                                    return str
                                        .replace(/[^a-z0-9_\-\.]/gi, '_') // remplace tout caractère non autorisé par "_"
                                        .replace(/_+/g, '_') // remplace les doubles underscores par un seul
                                        .replace(/^_+|_+$/g, ''); // retire les underscores en début/fin
                                }

                                const safeOrganisme = sanitizeFilename(props.nom_organisme);
                                const safeBudget = sanitizeFilename(props.nom_budget);
                                const filename = (
                                    `${safeOrganisme}_${safeBudget}_RETRO_${props.fctinv}_${props.recdep}`
                                ).replace("'", "").toUpperCase();
                                await exportGrilleSaisieCsv(props.objet, props.annees, filename, props.recdep);
                            }}
                        >
                            <Download width="12"/>
                            <p style={{marginLeft: 5}}>Exporter Excel</p>
                        </button>

                        <div style={{flex: 1}}></div>

                        {props.user && props.user.droits && props.user.droits.retro_saisie.includes("M") &&
                        <button
                            className='shadow-md rounded-md'
                            style={{backgroundColor: green, color: 'white', marginRight: 20, fontSize: 14, display: 'flex', alignItems: 'center', justifyContent: 'center', paddingLeft: 10, paddingRight: 10}}
                            onClick={async () => {
                                setValidButton(true)
                                await props.setAff(!props.aff)
                                await validation()
                                .then(() => {
                                    NotificationManager.success("Grille sauvegardée", '', 700);
                                    setTimeout(() => window.location = window.location.href, 900);
                                })
                            }}
                        >
                            <Check width="12"/>
                            <p style={{marginLeft: 5}}>Valider</p>
                        </button>
                        }
                    </div>
                    
                    {/* Tableau Grille Saisie */}
                    <div style={{flex: 1}}>
                        <div className='table-auto shadow-2xl rounded-md' style={{flex: 1, margin: 20, backgroundColor: 'white'}}>
                            
                            <div style={{flex: 1, display: 'flex', overflowY: 'scroll', backgroundColor: blue, color: 'white'}}>
                                <div style={{flex: 3, textAlign: 'center', minWidth: 150}}>
                                    <p style={{fontSize: 18, margin: 10}}>Compte</p>
                                </div>
                                {props.annees.map((annee, j) =>
                                    <div key={j} style={{flex: 1, fontSize: 15, borderLeft: '1px solid white', textAlign: 'center', minWidth: 50}}>
                                        <p style={{fontSize: 18, margin: 10}}>{annee}</p>
                                    </div>
                                )}
                            </div>

                            <div style={{flex: 1, overflowY: 'scroll', maxHeight: heightObject}}>
                            {props.objet && props.objet.length > 0 &&
                            props.objet.map((ligne, i) =>
                            (souscomptes || (!souscomptes && ligne[0][3] !== 3)) && (!ligne[0][0].includes('2014M4312') || props.user.id_organisme_type === '4')?
                                <div key={i} style={ligne[0][3] !== 3 && !ligne[0][0].includes('OOB') && !ligne[0][0].includes('RAR') && !ligne[0][0].includes('R00') && !ligne[0][0].includes('2014M4312') && !ligne[0][0].includes('D00')?{display: 'flex', flex: 1, minHeight: 35, borderTop: '1px solid white', backgroundColor: greyChapter}:i % 2 !== 0?{display: 'flex', flex: 1, minHeight: 35}:{display: 'flex', flex: 1, minHeight: 35, backgroundColor: smoothGrey}}>
                                    {/* Numero de compte et intitulé */}

                                    <div style={{display: 'flex', flex: 3, fontSize: 14, minWidth: 150}}>
                                        {ligne[0][3] !== 3 && !ligne[0][0].includes('OOB') && !ligne[0][0].includes('RAR') && !ligne[0][0].includes('R00') && !ligne[0][0].includes('2014M4312') && !ligne[0][0].includes('D00')?
                                        <div style={{display: 'flex', margin: 5}}>
                                            <p style={{fontWeight: "bold", color: 'red'}}>{ligne[0][1] != ''?ligne[0][1]:'-'}</p>
                                            <p style={{flex: 1, marginLeft: 5, fontWeight: "bold",color: 'black'}}>{ligne[0][2]}</p>
                                        </div>
                                        :
                                        <div style={{display: 'flex', margin: 5}}>
                                            <p style={{color: 'red', marginLeft: 30}}>{ligne[0][1] != ''?ligne[0][1]:'-'}</p>
                                            <p style={{flex: 1, marginLeft: 5, color: 'black'}}>{ligne[0][2]}</p>
                                        </div>}
                                    </div>

                                    {ligne.map((col, j) =>
                                    j != 0?
                                    ligne[0][3] !== 3 && !ligne[0][0].includes('OOB') && !ligne[0][0].includes('RAR') && !ligne[0][0].includes('R00') && !ligne[0][0].includes('2014M4312') && !ligne[0][0].includes('D00')?
                                    <div key={j} style={{flex: 1, display: 'flex', fontSize: 12, borderLeft: '1px solid white', minWidth: 50}}>
                                        {/* cellules pour les chapitres grisées */}
                                        <input
                                        type="float"
                                        style={col[1][recdep] === undefined?{flex: 1, width: 50, border: '0px solid black', textAlign: 'right', fontWeight: "bold"}:col[1][1] === '0'?{flex: 1, width: 50, border: '0px solid black', textAlign: 'right', fontWeight: "bold"}:{flex: 1, width: 50, border: '0px solid black', padding: 5, textAlign: 'right', fontWeight: "bold"}}
                                        placeholder={addSpace(Math.round(col[1][recdep] * 100) / 100)}
                                        disabled
                                        />
                                    </div>
                                    :
                                    <div key={j} style={{flex: 1, display: 'flex', fontSize: 12, borderLeft: '1px solid white', minWidth: 50}}>
                                        {/* cellules pour les lignes non grisées */}
                                        <input
                                        type="float"
                                        style={i%2===0?{flex: 1, textAlign: 'right', borderLeft: '1px solid white', width: 100, padding: 2, backgroundColor: smoothGrey}:{flex: 1, textAlign: 'right', borderLeft: '1px solid '+smoothGrey, width: 100, padding: 2}}
                                        placeholder={addSpace(Math.round(col[1][recdep] * 100) / 100)}
                                        onBlur={async (e) => {
                                            e.target.value = e.target.value.replace(',', '.').replace(/ /g, "")
                                            if (e.target.value !== '' && (parseFloat(e.target.value)))
                                            {
                                                e.target.value = parseFloat(e.target.value)
                                                await updateObjetLine(ligne[0][0], col[0], parseFloat(Math.round(e.target.value * 100) / 100).toString())
                                                .then(async(tmp) => {
                                                    await recalcule(tmp)
                                                })
                                                await props.setAff(!props.aff)
                                            }
                                            else if (e.target.value === '0')
                                            {
                                                await updateObjetLine(ligne[0][0], col[0], parseFloat(e.target.value).toString(), false)
                                                .then(async(tmp) => {
                                                    await recalcule(tmp)
                                                })
                                                await props.setAff(!props.aff)
                                            }
                                            e.target.value = ''
                                        }}
                                        />
                                    </div>
                                    :null)}
                                </div>
                                :null)}
                            </div>

                        </div>
                    </div>
                </div>}
            </Access>
        </div>
	);
}

export default GrilleSaisie;
